import React from "react";
import cn from "classnames";

interface LoaderProps {
    type?: "fullScreen" | "container";
    size?: "small" | "medium";
}

const Loader: React.FC<LoaderProps> = ({ type, size = "medium" }) => {
    return (
        <main>
            <div
                className={cn("loader", size, {
                    fullScreen: type === "fullScreen",
                })}
            >
                <div className="lds-ellipsis">
                    <div></div>
                    <div></div>
                </div>
            </div>
        </main>
    );
};

export default Loader;
